import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
interface PlayButtonProps {
  isVisible: boolean;
}
export const PlayButton: React.FC<PlayButtonProps> = ({
  isVisible
}) => {
  return (
    <div className={cn(
      "absolute inset-0 flex items-center justify-center transition-opacity duration-200 pointer-events-none",
      isVisible ? "opacity-100" : "opacity-0"
    )}>
      <img 
        src="/lovable-uploads/575a2bb1-d107-4904-aee1-b9abecc713b6.png" 
        alt="Play" 
        className="w-8 h-8 pointer-events-auto cursor-pointer" 
      />
    </div>
  );
};